// https://observablehq.com/@mbostock/tadpoles
class Bubbles {

	constructor() {
		this.width = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;

		this.height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;


		let n = 8;
		let v = .4;
		let m = 12;
		let canvas = document.getElementById('canvas');
		const koekkruimel = document.getElementById('koekkruimel');
		this.kruimelpaths = ["m402.87,310c0,6.42-1.82,11.81-3.02,17.88-1.24,6.26,3.26,13.94.87,19.7-2.43,5.86-1.44,14.55-4.92,19.75-3.51,5.25-12.04,7.53-16.48,11.98-4.45,4.45-7.52,11.79-12.77,15.3s-11.09,8.54-16.95,10.97c-5.76,2.39-15.85-8.95-22.11-7.72s-11.06,11.07-17.49,11.07-13.49.63-19.56-.57-11.14-7.95-16.9-10.34c-5.86-2.43-12.65-3.25-17.86-6.74-5.25-3.51-13.94-4.14-18.39-8.59-4.45-4.45-3.19-14.4-6.71-19.65-3.49-5.21-6.42-10.64-8.85-16.5-2.39-5.76-2.25-12.05-3.48-18.3s-4.56-11.83-4.56-18.25,2.11-12.43,3.31-18.5c1.24-6.26-2.09-14.14.3-19.9,2.43-5.86,8.56-10.29,12.04-15.49,3.51-5.25,8.15-9.72,12.6-14.16,4.45-4.45,6.42-12.82,11.66-16.34,5.21-3.49,11.1-8.38,16.96-10.81s13.49-2.57,19.75-3.81,13.27,1.67,19.69,1.67,13.97-4.62,20.04-3.42c6.26,1.24,8.42,15.76,14.18,18.15,5.86,2.43,10.05,5.08,15.25,8.57,5.25,3.51,11.43,4.26,15.87,8.71,4.45,4.45,13.55,5.03,17.06,10.28,3.49,5.21.3,13.94,2.73,19.8,2.39,5.76,12.74,9.29,13.98,15.55,1.2,6.07-6.25,13.29-6.25,19.71Z",
							"m367.84,310c0,6.46-1.68,11.8-3.57,17.63s-1.14,13.28-4.8,18.31c-3.7,5.08-6.61,12.35-11.69,16.05-5.03,3.66-12.86,4.12-18.91,6.09-5.83,1.89-12.41,5.3-18.87,5.3s-14.08-.2-19.91-2.09c-6.04-1.96-7.85-12.48-12.88-16.14-5.08-3.7-13.37-3.83-17.07-8.92-3.66-5.03-7.59-10.87-9.56-16.92-1.89-5.83.09-12.84.09-19.3s-.49-12.99,1.4-18.82c1.96-6.04,2.45-13.79,6.11-18.82,3.7-5.08,11.77-6.78,16.85-10.48,5.03-3.66,10.53-6.5,16.57-8.47,5.83-1.89,11.92-1.66,18.39-1.66s12.71-.71,18.54,1.19c6.04,1.96,11.13,5.63,16.16,9.29,5.08,3.7,12.14,5.96,15.84,11.04s4.96,12.01,6.92,18.05c1.89,5.83.37,12.21.37,18.67Z",
							"m347.43,310c0,7.06-2.15,12.76-5.45,18.46-3.4,5.88-6.31,12.41-12.19,15.81s-12.72,7.31-19.79,7.31-14.05-4.07-19.76-7.37c-5.88-3.4-12.36-7.82-15.77-13.71-3.3-5.7-6.17-13.45-6.17-20.51s7.12-12.35,10.42-18.05c3.4-5.88,5.45-13.09,11.33-16.49,5.7-3.3,12.88-5.88,19.94-5.88s13.5,3.86,19.2,7.16c5.88,3.4,11.53,7.67,14.93,13.55,3.3,5.7,3.3,12.64,3.3,19.71Z"]

		this.scale = 6;

		canvas.setAttribute('width', this.width)
		canvas.setAttribute('height', this.height)

		this.context = canvas.getContext('2d');

		this.tadpoles = new Array(n).fill().map(() => ({
			vx: (-Math.random()) * v,
			vy: (-Math.random()) * v,
			px: new Array(m).fill(Math.random() * this.width),
			py: new Array(m).fill(Math.random() * this.height),
			count: 0,
			innerSize: Math.random() * 4
		}));

		setInterval(() => this.draw(), 10);

	} 

	draw() {
		this.context.clearRect(0, 0, this.width, this.height);
		
		for (const [i, t] of this.tadpoles.entries()) {
			let dx = t.vx;
			let dy = t.vy;
			let x = t.px[0] += dx;
			let y = t.py[0] += dy;
			// let speed = Math.sqrt(dx * dx + dy * dy);
			// const count = speed * 10;
			// const k1 = -5 - speed / 8;

			// Bounce off the walls. // NOT BOUNCING? WHAT IS THIS FOR?
			// console.log(x)

			// circle
			// this.context.save();
			// this.context.translate(t.px[0], t.py[0]);
			// this.context.rotate(Math.atan2(t.vy, t.vx));
			// this.context.beginPath();
			// this.context.fillStyle = "#EE39EF";
			// this.context.ellipse(0, 0, 8, 8, 0, 0, 2 * Math.PI);
			// this.context.fill();

			// // inner circle
			// this.context.beginPath();
			// this.context.fillStyle = "#FFF";
			// this.context.ellipse(0, 0, t.innerSize, t.innerSize, 0, 0, 2 * Math.PI);
			// this.context.fill();
			// this.context.restore();

			let p = new Path2D(this.kruimelpaths[i % 3]);

			this.context.save(); // why?
			this.context.scale(1 / this.scale, 1 / this.scale);
			this.context.translate(t.px[0] * this.scale, t.py[0] * this.scale);
			this.context.rotate(Math.atan2(t.vy, t.vx));
			// console.log(Math.atan2(t.vy, t.vx));
			// this.context.rotate(45 * Math.PI / 180);
			// console.log(45 * Math.PI / 180);
			this.context.fillStyle = "#00DEB2";
			this.context.fill(p);
			this.context.restore();

			if (x < 0 || x > this.width) t.px[0] = this.width;
			if (y < -10 || y > this.height) t.py[0] = this.height;
		}
	}
}

export default Bubbles;